let USDollar = new Intl.NumberFormat('en-US', {
    currency: 'USD',
});

var sureshipId = '41256592965694';
var setupId = '41256594669630';

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

jQuery(document).ready(function(){

  //click on step2 config
  $(".step2_config, .next_step2").click(function(){
    if ($("input[name='delivery_time']:checked").length > 0) {

          $(this).addClass("active");
          $(".sub_step2_config").css("display", "block");
          $(".step1_config").removeClass("active");
          $(".sub_step1_config").css("display", "none");
          $(".step2_config").css("pointer-events", "auto");


    } else {
     //alert("Please select all the options");
      return false;
    
    } 
  });


  // //click on step3 config
  $(".step3_config, .next_step3").click(function() {

    // if (isAnyFilled) {
      $(".quantity.active").removeClass("active");
      $(".sub_step3_config").css("display", "block");
      $(".step2_config").removeClass("active");
      $(".sub_step2_config").css("display", "none");
       $(".step3_config").css("pointer-events", "auto");
    // } else {
    //   alert("None of the options are checked");
    // }
  });

  //click on decoratead_type 


  $('input[name="decorated_type"]').on('change', function() {
      var decorated_type  =  $(this).val();
    console.log(decorated_type);
        if(decorated_type == 'blank'){
     
            $(".custom_order").css("pointer-events", "auto");
            $(".custom_order").css("background-color", "#fd7600");
            $(".step4_config").css("display", "none");
            $(".step5_config").css("display", "none");
            $(".step6_config").css("display", "none");
            $(".step7_config").css("display", "none");
            $(".sub_step4_config").css("display", "none");
            $(".sub_step6_config").css("display", "none");
            $(".sub_step7_config").css("display", "none");
        } else {
           $(".custom_order").css("pointer-events", "none");
           $(".custom_order").css("background-color", "#e1791d94");
           $(".step4_config").css("display", "block");
           $(".step4_config").css("pointer-events", "auto");
           $(".step5_config").css("display", "block");
           $(".step6_config").css("display", "block");
           $(".step7_config").css("display", "block");
           $(".sub_step4_config").css("display", "none");
            $(".sub_step6_config").css("display", "none");
            $(".sub_step7_config").css("display", "none");
        }

    });

 $('input[name="decoration_method"]').on('change', function() {

   
      $("input[name='decoration_method']:not(:checked)").each(function() {
          var decoration_method_class = $(this).attr('decoration-location');
          console.log(decoration_method_class);
          $("."+decoration_method_class).css("display", "none");
      });
    
   
    if ($("input[name='decoration_method']:checked").length > 0) {
            var decoration_method  =  $("input[name='decoration_method']:checked").attr('decoration-location');
            $("."+decoration_method).css("display", "block");
            $(".sub_step3_config").css("display", "none");
            $(".sub_step4_config").css("display", "none");
            $(".sub_step6_config").css("display", "block");
            $(".step6_config").css("pointer-events", "auto");
    }
});


 $('input[name="decoration_location"]').on('change', function() {

    $(".sub_step6_config").css("display", "none");
    $(".sub_step7_config").css("display", "block");
    
    $(".step6_config").removeClass("active");
});

$(".step7_config").click(function(){
    $(".sub_step4_config").css("display", "none");
    $(".sub_step6_config").css("display", "none");
    $(".step4_config").removeClass("active");
    $(".step6_config").removeClass("active");
});


  

  
 $('input[name="add_art"]').on('change', function() {    
    if ($("input[name='add_art']:checked").length > 0) {
       var add_art  =  $(this).val();   
            $(".sub_step5_config").css("display", "none");
            $(".sub_step6_config").css("display", "block");
            $(".step6_config").css("pointer-events", "auto");
    }
 });
  
 $('input[name="decoration_location"]').on('change', function() {    
    if ($("input[name='decoration_location']:checked").length > 0) {
       var decoration_location  =  $(this).val();   
      if(decoration_location == 'custom_heigh_and_width')
      {
          $(".custom_height_width").removeAttr("disabled");
      }else {
        $(".custom_height_width").attr("disabled", true);
      }
            $(".custom_order").css("pointer-events", "auto");
            $(".custom_order").css("background-color", "#fd7600");
    }
 });


 

    $(".quantity").on("change", function() {
        $(".custom_order").css("pointer-events", "auto");
        $(".custom_order").css("background-color", "#fd7600");

      var quantity = $(this).val();
      var price = $("#variant-select").children("option").filter(":selected").attr("data-price");
      var totalPrice = quantity * price;
     // $("#total-price").text(totalPrice.toFixed(2)); 
    });

  
    $('input[name="Size"]').on("change", function() {
      var checkedValues = [];
      $('input[name="Size"]:checked').each(function() {
        checkedValues.push($(this).val());
      });
      var variantId = $("input[name='order_sample_varient']:checked").val();
      var combinedValues = checkedValues.map(function(size) {
        return variantId + ' / ' + size;
      });
      var variantSelect = $('#variant-select');
      
     
      var subtotal = 0; // Initialize subtotal to zero
    combinedValues.forEach(function(combinedValue) {
      var matchingOption = variantSelect.find('option[data-name="' + combinedValue + '"]');
      if (matchingOption.length > 0) {
      
         var dataPrice = parseFloat(matchingOption.attr('data-price')); // Parse the price as a float
        
       subtotal += dataPrice;
      } else {
        console.log('No matching data-name found for:', combinedValue);
      }
    });
     $("#total_price_sample").text(subtotal.toFixed(2));
  });
 

$(".step4_config").click(function(){
    $(".sub_step3_config").css("display", "none");
    $(".sub_step6_config").css("display", "none");
    $(".sub_step7_config").css("display", "none");
    $(".step3_config").removeClass("active");
});
  
$(".step6_config").click(function(){
    $(".sub_step4_config").css("display", "none");
    $(".sub_step7_config").css("display", "none");
    $(".step4_config").removeClass("active");
      var decoration_method = $("input[name='decoration_method']:checked").attr('decoration-location');
      $("input[name='decoration_method']:not(:checked)").each(function() {
          var decoration_method_class = $(this).attr('decoration-location');
          $("."+decoration_method_class).css("display", "none");
      });
      $("."+decoration_method).css("display", "block");
      $(".custom_order").css("pointer-events", "auto");
      $(".custom_order").css("background-color", "#fd7600");
});


$(".inside_tab_varient").click(function(){
    var targetValue = $(this).attr('data-value');
 
  $(".color-label").text(targetValue);

  $('input:radio[name=inside_tab_varient]').filter('[value="'+ targetValue +'"]').prop('checked', true);
  $('input:radio[name=order_config_varient]').filter('[value="'+ targetValue +'"]').prop('checked', true);
  $('input:radio[name=order_sample_varient]').filter('[value="'+ targetValue +'"]').prop('checked', true);
  
  var sku = $('input:radio[name=inside_tab_varient]:checked').attr('data-sku');
  $(".v_item").hide();
  $(".v_"+sku).show();
  
});

  
 $(".color-label").text($("input[name='inside_tab_varient']:checked").val());
  $(".v_item").hide();
   var sku = $('input:radio[name=inside_tab_varient]:checked').attr('data-sku');
  $(".v_"+sku).show();
});
  



// Create virtual tab****************************************************************

  $(".step2_virtual, .next_step2_virtual").click(function(){
    if ($("input[name='virtual_varient']:checked").length > 0 && $("input[name='delivery_time_virtual']:checked").length > 0) {
      
          $(this).addClass("active");
          $(".sub_step2_virtual").css("display", "block");
          $(".step1_virtual").removeClass("active");
          $(".sub_step1_virtual").css("display", "none");
          $(".step2_virtual").css("pointer-events", "auto");
    } else {
   
     alert("Please select all the options");
      return false;
    
    } 
  });




  //tabs

  function openTab1(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent1");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
      tabcontent[i].className = tabcontent[i].className.replace("tab-cart", "");
    }
    tablinks = document.getElementsByClassName("tablinks1");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
   var element = document.getElementById(cityName);
   element.classList.add("tab-cart");
    evt.currentTarget.className += " active";
  }

  function openTab2(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent2");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks2");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  //accordion

  var acc = document.getElementsByClassName("accordion");
  var j;

  for (j = 0; j < acc.length; j++) {
    acc[j].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }




function order_cart(){
  //setup fee 
  var sureship = $("input[name='delivery_time']:checked").val();
 if(sureship == 'sureship'){
  sureship =   "Sureship";
 } else {
 sureship =  "Standard lead time";
 }
    
    var  decoration_type = $('input[name="decorated_type"]:checked').val();
    var  decoration_method = $('input[name="decoration_method"]:checked').val();
    var  decoration_location = $('input[name="decoration_location"]:checked').val();
    var  logo_upload = $('input[name="properties[upload]"]').val();
    var variant_id = $('.inside_tab_input:checked').data('id');
    $('#variant-select option[value='+variant_id+']').prop("selected",true);
    var total_price = $('#total_price').val();
    total_price = (total_price * 100);
    var variantName = $("input[name='order_config_varient']:checked").val();
    var quantity = $("input[name='quantity']").val();
    var sureship_check = false;
    var setup_check = false;
//for size
var sizeData = {};
$('.size-config').each(function() {
  var id = $(this).attr('id');
  var value = $(this).val();
  sizeData[id] = value;
});
  
// var items = [];
if(decoration_type != 'decorated' && sureship != 'Sureship'){
  var items = [];
} else if (decoration_type == 'decorated' && sureship != 'Sureship' ) {
var items = [{quantity: "1",
                id: setupId,
                properties: {
                    [`_${variant_id}`]: true,
                }}];
    setup_check = true;
}  else if (decoration_type != 'decorated' && sureship == 'Sureship' ) {
var items = [{quantity: "1",
                id: sureshipId,
                properties: {
                    [`_${variant_id}`]: true
                }}];
     sureship_check = true;
} else{

   var items = [{quantity: "1",
                id: setupId,
                properties: {
                    [`_${variant_id}`]: true
                }},
               {quantity: "1",
                id: sureshipId,
                properties: {
                    [`_${variant_id}`]: true
                }}
               ];
     sureship_check = true;
    setup_check = true;
}

for (var id in sizeData) {
  if (sizeData.hasOwnProperty(id)) {
    var quantity = sizeData[id];
    
    if (quantity !== null && quantity !== "") { // Check for null or empty quantity
      var combinedValue = variantName + ' / ' + id;
      var matchingOption = $('#variant-select option[data-name="' + combinedValue + '"]');
      
      if (matchingOption.length > 0) {
        var variantID = matchingOption.val();


       if(decoration_type == 'blank'){
           var item = {
                quantity: parseInt(quantity), 
                id: parseInt(variantID),
                 properties: {
                    'How fast do you need this?': sureship,
                    'Decoration Type:': 'Blank',
                    "_decoration_price":total_price,
                    "_sureship_check" :sureship_check,
                    "_setup_check" :setup_check
                  }
              };
        } else {
           var item = {
                quantity: parseInt(quantity), 
                id: parseInt(variantID),
                 properties: {
                    'How fast do you need this? ': sureship,
                    'Decoration Type:': 'Decorated',
                    'Decoration Method:' : decoration_method,
                    'Decoration Location:' : decoration_location,
                    'Logo:' : logo_upload,
                    "_decoration_price":total_price,
                   "_sureship_check" :sureship_check,
                    "_setup_check" :setup_check

                  }
              }
                      
        }
        
        items.push(item);
      } else {
        console.log('No matching data-name found for:', combinedValue);
      }
    }
  }
}

//for qty
   var varient = $("#variant-select").children("option").filter(":selected").val();
  
  
 if (Object.keys(sizeData).length === 0) {

    if(decoration_type == 'blank'){
           var send_items = {
                quantity:quantity, 
                id: varient,
                 properties: {
                    'How fast do you need this? ': sureship,
                    'Decoration Type:': 'Blank',
                   "_decoration_price":total_price,
                   "_sureship_check" :sureship_check,
                    "_setup_check" :setup_check
                  }
              };
     
        } else {
              var send_items = {
                        quantity: quantity,
                        id: varient,
                         properties: {
                            'How fast do you need this? ': sureship,
                            'Decoration Type:': 'Decorated',
                            'Decoration Method:' : decoration_method,
                            'Decoration Location:' : decoration_location,
                            'Logo:' : logo_upload,
                           "_decoration_price":total_price,
                           "_sureship_check" :sureship_check,
                           "_setup_check" :setup_check
                          }
                      }
                      ;
     
           
        }
        items.push(send_items);
    //for qty
         console.log(items);

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:  { items: items },
              
        dataType: 'json',
        success: function (data) {     
           updateCartCount();
       window.location.href = "/cart";      
        }
    });
  }  else {
      //for size
     $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { items: items },
            dataType: 'json',
            success: function (data) {
             
               updateCartCount();
              window.location.href = "/cart"; 
            },
            error: function (error) {
                
            }
          });
  }


}



//sample_cart
function order_sample_cart(){
  //for qty
 var varient = $("input[name='order_sample_varient']:checked").attr('data-id');
 var quantity = $('#max_qty').children("option").filter(":selected").val();
 var total_price = $('#total_sample_price').val();
 total_price = (total_price * 100);

  //for size
 var allSize = [];
      $('input[name="Size"]:checked').each(function() {
        allSize.push($(this).val());
      });
      var variantName = $("input[name='order_sample_varient']:checked").val();
      var combinedValues = allSize.map(function(size) {
        return variantName + ' / ' + size;
      });
      var variantSelect = $('#variant-select');
    var items = [];

    combinedValues.forEach(function(combinedValue) {
      var matchingOption = variantSelect.find('option[data-name="' + combinedValue + '"]');
      if (matchingOption.length > 0) {
        var varientID = matchingOption.val();
        var item = {
          quantity: 1, 
          id: parseInt(varientID),
          properties: { 
                       "_decoration_price":total_price
                      }
        };
        items.push(item);
      } else {
        console.log('No matching data-name found for:', combinedValue);
      }
    });

   if(allSize.length==0){
  //for qty
   $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {          
              quantity: quantity,
              id: varient,
              properties: { 
                           "_decoration_price":total_price
                          }
          },
        dataType: 'json',
        success: function (data) {   
          //console.log(data)
           updateCartCount();
           window.location.href = "/cart";   
        },
        error: function (error) {
          console.error('Error:', error);
      }
    });
 }else {
    //for size
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: items }, // Send the items array in the data
      dataType: 'json',
      success: function (data) {
        // Handle success
           updateCartCount();
       window.location.href = "/cart";
      },
      error: function (error) {
        // Handle error
        console.error('Error:', error);
      }
    });
 }
}

$(document).on("click", ".calculate-quantities-button", function() {
  $('.size-config').each(function() {
    var id = $(this).attr('id');
    var quantityDisplay = $(this).siblings('.display_qty_here'); // Get the display quantity element
    var variantSelect = $('#variant-select');
    var variantName = $("input[name='order_config_varient']:checked").val();
    var combinedValue = variantName + ' / ' + id;
    var matchingOption = variantSelect.find('option[data-name="' + combinedValue + '"]');
    if (matchingOption.length > 0) {
      var dataQuantity = parseInt(matchingOption.attr('data-quantity'));
       quantityDisplay.text('Qty: ' + dataQuantity);
    } else {
      console.log('No matching data-name found for:', combinedValue);
    }
  });
});

$(document).on("keyup", ".size-config", function() {
  var total = 0; // Initialize total to zero
  $('.size-config').each(function() {
    var id = $(this).attr('id');
    var quantity = $(this).val(); // Get the quantity entered in the input field
    var variantSelect = $('#variant-select');
    var variantName = $("input[name='order_config_varient']:checked").val();
    var combinedValue = variantName + ' / ' + id;
    var matchingOption = variantSelect.find('option[data-name="' + combinedValue + '"]');
    
    if (matchingOption.length > 0) {
      var dataPrice = parseFloat(matchingOption.attr('data-price')); // Get the price from the selected option
      
      if (!isNaN(quantity)) {
        total += dataPrice * quantity; // Add to the total
      }
    } else {
      console.log('No matching data-name found for:', combinedValue);
    }
  });

  // Update the UI with the calculated total
 // $("#total-price").text(total.toFixed(2));
});

//update cart values 
function updateCartCount() {

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      var cartItems = cart.items;
      var cartCount = 0;
      // Calculate the cart count, excluding specific product IDs
      cartItems.forEach(function (item) {
    
        if(item.id != setupId && item.id != sureshipId && item.title != 'Decoration Price' ){
          cartCount += item.quantity;       
        }
       
      });
      $('.cart_count').text(cartCount); 
      $('#cart-count-m').text(cartCount); 
    }
  });
}



                      